import script from "./DeliveriesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveriesView.vue?vue&type=script&setup=true&lang=ts"

import "./DeliveriesView.vue?vue&type=style&index=0&id=64fc0b10&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64fc0b10"]])

export default __exports__